"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newConsentFlow = exports.isSummerLearningWithoutDiscountVariant = exports.isPtlInvitationVariant = exports.isOneClickAssignmentVariant = exports.isOldObwOnNewDashboardVariant = exports.isNewAddSchool = exports.isNPSImprovements = exports.isMathFactAdaptiveDefaultQuestionVariant = exports.isHomeWidgetAndAccessPageVariant = exports.isFtueVariant = exports.isClassReportRevampVariant = exports.isBookRecommendationVariant = exports.isBookLibraryCcssTagVariant = exports.isAssignmentExpiryVariant = exports.hasClassHealthMeterVariant = exports.hasAssessmentPitchPageVariant = exports.enableHomeAccessButtonVariant = exports.dashboardMigrationAbTest = void 0;
//Common mapping file to map Ab test conditions from their respective segments

var hasAssessmentPitchPageVariant = exports.hasAssessmentPitchPageVariant = function hasAssessmentPitchPageVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::AssesmentPitchPage"];
  if (!abtestSegment || abtestSegment == 'control') return false;else return true;
};
var hasClassHealthMeterVariant = exports.hasClassHealthMeterVariant = function hasClassHealthMeterVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::ClassHealthMeter"];
  if (!abtestSegment || abtestSegment == 'Class Health Meter - Control') return false;else return true;
};

// abtest has been concluded to Variant
// export const hasGridReportVariant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::GridReports"]
//   if(!abtestSegment || abtestSegment.includes('Control')) return false
//   else return true
// }

// abtest has been concluded to Variant
// export const hasAssignmentThroughGridReportVariant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::AssignmentThroughGridReport"]
//   if(!abtestSegment || abtestSegment == 'control') return false
//   else return true
// }

// abtest has been concluded to Variant
// export const hasCommonPasswordVariant = (params: any): boolean => { 
//   const abtestSegment = params?.["Teacher::CommonPassword"]
//   if(!abtestSegment || abtestSegment == 'control') return false
//   else return true
// }

//Note: This ab test corresponds to isRemoteLearning variable in react app
var isHomeWidgetAndAccessPageVariant = exports.isHomeWidgetAndAccessPageVariant = function isHomeWidgetAndAccessPageVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::HomeWidgetAndAccessPage"];
  if (!abtestSegment || abtestSegment == 'control') return false;else return true;
};

// abtest has been concluded to Variant
// export const showSurveyQuestionsAbtest = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::Survey"]
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

// abtest has been concluded to Control
var enableHomeAccessButtonVariant = exports.enableHomeAccessButtonVariant = function enableHomeAccessButtonVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::HomeAccessButtonName"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};
var isPtlInvitationVariant = exports.isPtlInvitationVariant = function isPtlInvitationVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::PtlInvitation"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};

// abtest has been concluded to Control
// export const isHomeAccessRevampPageVariant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::HomeAccessRevampPage"]
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

var isMathFactAdaptiveDefaultQuestionVariant = exports.isMathFactAdaptiveDefaultQuestionVariant = function isMathFactAdaptiveDefaultQuestionVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::MathFactAdaptiveDefaultQuestion"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};

// abtest has been concluded to Variant
// export const isDashboardRevampVariant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::DashboardRevamp"]
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

// abtest has been concluded to Variant
// export const showSplashCommunityAbTest = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::CircleCommunity"]
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

// abtest has been concluded to Variant
// export const showAddParentEmailScreenAbTest = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::AddParentEmailScreen"]
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

var dashboardMigrationAbTest = exports.dashboardMigrationAbTest = function dashboardMigrationAbTest(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::ShowNewTeacherDashboard"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};
var isSummerLearningWithoutDiscountVariant = exports.isSummerLearningWithoutDiscountVariant = function isSummerLearningWithoutDiscountVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::SummerLearningWithoutDiscount"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};

// abtest has been concluded to Variant
var isOneClickAssignmentVariant = exports.isOneClickAssignmentVariant = function isOneClickAssignmentVariant(params) {
  var abtestSegment = (params === null || params === void 0 ? void 0 : params["Teacher:OneClickAssignment"]) || (params === null || params === void 0 ? void 0 : params["Teacher::OneClickAssignment"]);
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};

// abtest has been concluded to Control
var isFtueVariant = exports.isFtueVariant = function isFtueVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::FTUE"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};

// abtest has been concluded to Variant
// export const isLiveClassesByTeacherVariant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::LiveClassesByTeacher"]
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

// abtest has been concluded to Variant
var isOldObwOnNewDashboardVariant = exports.isOldObwOnNewDashboardVariant = function isOldObwOnNewDashboardVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::OldObwOnNewDashboard"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};

// Web abtest has been concluded to Variant
// export const isDRSFlutterTeacher = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::DRSFlutter"]
//   if (abtestSegment && abtestSegment === 'Flutter') return true
//   else return false
// }

// abtest has been concluded to Variant
var isNPSImprovements = exports.isNPSImprovements = function isNPSImprovements(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::NPSImprovements"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};

// abtest has been concluded to Variant
// export const isHomeAccessCopyImprovementVariant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::HomeAccessCopyImprovement"]
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

// abtest has been concluded to Variant
// export const isBookLibraryP3Variant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::BookLibrary"]
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

var newConsentFlow = exports.newConsentFlow = function newConsentFlow(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::CookieManager"];
  if (!abtestSegment || abtestSegment === 'control') return false;else return true;
};

// abtest has been concluded to Variant
// export const isNewTeacherOnboardingVariant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::NewTeacherOnboarding"]
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

// abtest not found.
var isNewAddSchool = exports.isNewAddSchool = function isNewAddSchool(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::AddSchool"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};

// abtest has been concluded to Variant
// export const isContinueReadingRailVariant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::ContinueReadingRail"];
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

// abtest has been concluded to Variant
// export const isBookCollectionsVariant = (params: any): boolean => {
//   const abtestSegment = params?.["Teacher::BookCollectionPhase1"];
//   if (!abtestSegment || abtestSegment === 'Control') return false
//   else return true
// }

var isAssignmentExpiryVariant = exports.isAssignmentExpiryVariant = function isAssignmentExpiryVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::AssignmentExpiry"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};
var isBookRecommendationVariant = exports.isBookRecommendationVariant = function isBookRecommendationVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::BookRecommendation"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};
var isClassReportRevampVariant = exports.isClassReportRevampVariant = function isClassReportRevampVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::ClassReportRevamp"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};
var isBookLibraryCcssTagVariant = exports.isBookLibraryCcssTagVariant = function isBookLibraryCcssTagVariant(params) {
  var abtestSegment = params === null || params === void 0 ? void 0 : params["Teacher::BookLibraryCcssTags"];
  if (!abtestSegment || abtestSegment === 'Control') return false;else return true;
};